<template>
	<section class="small-12 columns flex justify-center blogCategoriesList">
        <div class="small-12 large-10 columns wrap">
            <ul class="small-12 flex float-left flex justify-center">
                <li class="small-12 large-4 columns flex justify-center">
                    <router-link :to="{ name: 'BlogCategory', params: { slug: 'category-1' } }" class="bgPink borderRadius2 flex justify-center vertical-align">
                        Category 1
                    </router-link>
                </li>
                <li class="small-12 large-4 columns flex justify-center">
                    <a class="bgPrimaryBlue borderRadius2 flex justify-center vertical-align">
                        Category 2
                    </a>
                </li>
                <li class="small-12 large-4 columns flex justify-center">
                    <a class="bgYellow borderRadius2 flex justify-center vertical-align">
                        Category 3
                    </a>
                </li>
                <li class="small-12 large-4 columns flex justify-center">
                    <a class="bgSecondaryPurpleLight borderRadius2 flex justify-center vertical-align">
                        Category 4
                    </a>
                </li>
                <li class="small-12 large-4 columns flex justify-center">
                    <a class="bgAquaGreen borderRadius2 flex justify-center vertical-align">
                        Category 5
                    </a>
                </li>
                <li class="small-12 large-4 columns flex justify-center">
                    <a class="bgPrimaryBlueDark borderRadius2 flex justify-center vertical-align">
                        Category 6
                    </a>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'NameHere',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>